import { useCompanyListPageProps } from "@/pages/company-list/fetch";
import { CompanyListPageUi } from "@/pages/company-list/ui";
export const CompanyListPage = () => {
  const props = useCompanyListPageProps();

  return <CompanyListPageUi {...props} />;
};
